import IconThreeDot from "./icon-three-dot";

export default IconThreeDot;
